import Cookies from 'js-cookie';

// Cookie utility functions for token management
const getCookieOptions = (rememberMe: boolean = true) => ({
  secure: import.meta.env.PROD, // Only send over HTTPS in production
  sameSite: 'strict' as const,
  ...(rememberMe ? { expires: 90 } : {}), // 90 days if remembered, otherwise session cookie
});

export const cookieUtils = {
  // Set access token
  setAccessToken: (token: string, rememberMe: boolean = true) => {
    Cookies.set('accessToken', token, getCookieOptions(rememberMe));
  },

  // Get access token
  getAccessToken: (): string | undefined => {
    return Cookies.get('accessToken');
  },

  // Remove access token
  removeAccessToken: () => {
    Cookies.remove('accessToken');
  },

  // Remove all tokens
  // Note: refreshToken is now http-only cookie managed by backend
  clearTokens: () => {
    Cookies.remove('accessToken');
    // Refresh token is http-only cookie, cleared by backend on logout
  },

  // Set user data
  setUser: (user: any, rememberMe: boolean = true) => {
    Cookies.set('user', JSON.stringify(user), getCookieOptions(rememberMe));
  },

  // Get user data
  getUser: () => {
    const user = Cookies.get('user');
    return user ? JSON.parse(user) : null;
  },

  // Remove user data
  removeUser: () => {
    Cookies.remove('user');
  },
};

